import {
  ConfigToSendInterface,
  FixMe,
  TunnelVersion,
} from '@greenkub-fronts/shared/interface';

import { formatToMinimalistConfig } from '../../utils/configurationHelpers';
import { addErrorMessage } from '@greenkub-fronts/domain/snackbar';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const persistConfigurationsUseCase = createAsyncThunk(
  'persistConfigurationsUseCase',
  async (
    data,
    {
      dispatch,
      extra,
      getState,
    }: { dispatch: FixMe; extra: FixMe; getState: FixMe }
  ) => {
    const { currentProject, version } = getState().tunnel;

    if (![TunnelVersion.R1, TunnelVersion.KIT].includes(version)) {
      return {
        project: currentProject,
        status: 'success',
        errorModalIsOpen: false,
      };
    }

    if (!currentProject) {
      return { status: 'fail' };
    }

    let configsToSend: ConfigToSendInterface[];
    try {
      configsToSend = formatToMinimalistConfig(
        getState().tunnel.configurations
      );
    } catch (error: FixMe) {
      dispatch(addErrorMessage(error));
      return { status: 'fail' };
    }

    /**
     * Patch de configuration
     */
    const patchResult = await dispatch(
      extra.apiSlice.endpoints.patchConfigurations.initiate({
        projectId: currentProject.id,
        data: configsToSend,
      })
    );

    const errorModalIsOpen = false;
    let status = '';
    const project = currentProject;

    if (patchResult.error) {
      if (
        patchResult.error.data.message ===
        'Aucun studio possible avec cette combinaison'
      ) {
        dispatch(addErrorMessage(patchResult.error));
      }
      status = 'fail';
    }

    return {
      project,
      status,
      errorModalIsOpen,
    };
  }
);

export default persistConfigurationsUseCase;
